import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth, AuthenticationStatus } from "../../../context/auth-context";
// import { HomeNav } from "../../nav/homeNav";
import { isMobile } from "react-device-detect";
import { Logger, Auth } from "aws-amplify";
import { toast } from "../../../tabin/components/toast";
import { loginPath } from "../../main";

import * as yup from "yup";
import { useSmallScreen } from "../../../hooks/useWindowSize";
import { Button } from "../../../tabin/components/button";
import { Input } from "../../../tabin/components/input";

const logger = new Logger("Forgot password reset");

const verificationCodeSchema = yup
    // https://stackoverflow.com/questions/49886881/validation-using-yup-to-check-string-or-number-length
    // can't use .number, that doesn't work with leading zeros
    .string()
    .matches(/^[0-9]{6}$/, "The verification is exactly 6 digits long")
    .required("Please enter the verification code");
const newPasswordSchema = yup.string().required("Password is required").min(8, "Password must be at least 8 characters long");
const confirmPasswordSchema = yup.string().required("Confirm password is required").min(8, "Password must be at least 8 characters long");

export default () => {
    const { isSmallScreen } = useSmallScreen();
    const { email } = useAuth();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [serverError, setServerError] = useState("");
    const [verificationCodeError, setVerificationCodeError] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    useEffect(() => {
        if (!email) {
            navigate(loginPath, { replace: true });
        }
    });

    const onChangeVerificationCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        setVerificationCode(event.target.value);
        setVerificationCodeError("");
        setServerError("");
    };

    const onChangeNewPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewPassword(event.target.value);
        setNewPasswordError("");
        setServerError("");
    };

    const onChangeConfirmPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(event.target.value);
        setConfirmPasswordError("");
        setServerError("");
    };

    const onResetPassword = async () => {
        setLoading(true);
        let fieldsValid = true;

        try {
            await verificationCodeSchema.validate(verificationCode);
            setVerificationCodeError("");
        } catch (e) {
            setVerificationCodeError(e.message);
            fieldsValid = false;
        }

        try {
            await newPasswordSchema.validate(newPassword);
            setNewPasswordError("");
        } catch (e) {
            setNewPasswordError(e.message);
            fieldsValid = false;
        }

        try {
            await confirmPasswordSchema.validate(confirmPassword);
            setConfirmPasswordError("");
        } catch (e) {
            setConfirmPasswordError(e.message);
            fieldsValid = false;
        }

        if (newPassword !== confirmPassword) {
            setConfirmPasswordError("Passwords don't match");
            fieldsValid = false;
        }

        if (fieldsValid) {
            try {
                await Auth.forgotPasswordSubmit(email ? email : "", verificationCode, newPassword);
                toast.success(`Successfully reset password for ${email}`);
                setLoading(false);
                navigate(loginPath);
            } catch (e) {
                logger.debug("e", e);
                setServerError(e.message);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onResetPassword();
        }
    };

    const verificationCodeInput = (
        <>
            <Input
                name="verificationCode"
                label="Verification Code"
                type="text"
                onChange={onChangeVerificationCode}
                onKeyPress={onEnter}
                value={verificationCode}
                error={verificationCodeError}
            />
        </>
    );

    const newPasswordInput = (
        <>
            <Input
                name="newPassword"
                label="New Password"
                type="password"
                onChange={onChangeNewPassword}
                onKeyPress={onEnter}
                value={newPassword}
                error={newPasswordError}
            />
        </>
    );

    const confirmNewPasswordInput = (
        <>
            <Input
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                onChange={onChangeConfirmPassword}
                onKeyPress={onEnter}
                value={confirmPassword}
                error={confirmPasswordError}
            />
        </>
    );

    const resetPasswordButton = (
        <>
            <Button style={{ borderRadius: "8px", width: "100%", height: "52px" }} disabled={loading} onClick={onResetPassword} loading={loading}>
                <div className="text-bold">RESET PASSWORD</div>
            </Button>
        </>
    );

    const content = (
        <>
            <div
                style={
                    !isSmallScreen
                        ? {
                              padding: "24px",
                              margin: "0 auto",
                              width: "448px",
                              border: "1px solid #e4e4e4",
                          }
                        : {}
                }
            >
                <div className="h2">Reset password</div>
                <div className="mb-3"></div>
                <div>Your new password needs to have at least 8 characters.</div>
                <div className="mb-3"></div>
                {serverError && <div className="text-error mb-3">{serverError}</div>}

                {verificationCodeInput}
                <div className="mb-2"></div>
                {newPasswordInput}
                <div className="mb-2"></div>
                {confirmNewPasswordInput}
                <div className="mb-3"></div>
                {resetPasswordButton}
            </div>
        </>
    );

    return (
        <>
            {/* <HomeNav /> */}
            <div
                style={{
                    minHeight: "100vh",
                    maxWidth: "1080px",
                    margin: "auto",
                    padding: "24px",
                    paddingTop: isSmallScreen ? "24px" : "40px",
                    paddingBottom: isMobile ? "80px" : "unset", // for tab nav
                }}
            >
                {content}
            </div>
        </>
    );
};
